import { render } from "./ClassSection.vue?vue&type=template&id=09ab26a0&scoped=true"
import script from "./ClassSection.vue?vue&type=script&lang=js"
export * from "./ClassSection.vue?vue&type=script&lang=js"

import "./ClassSection.vue?vue&type=style&index=0&id=09ab26a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ab26a0"]])

export default __exports__